import MultiSelectPage from "@components/MultiSelectPage"

const OPTIONS = [
  "improveRelationshipWithFood",
  "learnCookHealthily",
  "strengthenImmuneSystem",
  "sleepBetterMoreEnergy",
  "feelComfortable",
  "noneOfAbove",
] as const

export default function AdditionalGoals() {
  return (
    <MultiSelectPage
      translationKey="additionalGoals"
      options={OPTIONS}
      noneOptionKey="noneOfAbove"
    />
  )
}
